module.exports = __webpack_public_path__ + "static/media/JonasDavidOcampoVazquez.fac81bda.png";